"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("@chakra-ui/react");
const react_2 = __importDefault(require("react"));
const utils_1 = require("./utils");
const TEMPLATE_AREAS = utils_1.COLUMNS_ORDER.join(' ');
const TEMPLATE_COLUMNS = utils_1.COLUMNS_ORDER.map((name) => utils_1.COLUMNS[name].size).join(' ');
const TableRow = ((props) => (react_2.default.createElement(react_1.Grid, { columnGap: "space-10", gridTemplateAreas: `"${TEMPLATE_AREAS}"`, gridTemplateColumns: TEMPLATE_COLUMNS, padding: "space-8", ...props })));
const getColumnComponent = (columnName) => {
    const Component = (props) => (react_2.default.createElement(react_1.Box, { gridArea: columnName, ...utils_1.COLUMNS[columnName].style, ...props }));
    Component.displayName = `TableRow.Column${columnName}`;
    return Component;
};
TableRow.ColumnDetails = getColumnComponent(utils_1.ColumnName.Details);
TableRow.ColumnUnits = getColumnComponent(utils_1.ColumnName.Units);
TableRow.ColumnUnitPrice = getColumnComponent(utils_1.ColumnName.UnitPrice);
TableRow.ColumnVatPercentage = getColumnComponent(utils_1.ColumnName.VatPercentage);
TableRow.ColumnTotalWithoutTaxes = getColumnComponent(utils_1.ColumnName.TotalWithoutTaxes);
exports.default = TableRow;
